// extracted by mini-css-extract-plugin
export var banner = "_bm-0";
export var closeButton = "_bm-2";
export var greenCheckmark = "_bm-3";
export var hereLink = "_bm-4";
export var titleIcon = "_bm-1";